var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanningIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.072,
    height: 83.981,
    viewBox: "0 0 84.072 83.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#f6d2bf;}.c{fill:#013272;}.d{fill:#013b88;}.e{fill:#00429a;}.f{fill:#0075eb;}.g{fill:#f0c3ab;}.h{fill:#1a8cff;}.i{fill:#f7ded0;}.j{fill:#fc6fd0;}.k{fill:#fc98dd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.776 19.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z",
    transform: "translate(-19.553 -19.742)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.224 -2.733)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.125,321.283l-.957,9.086a6.167,6.167,0,0,1-3.147,4.833l-8.779,4.877a4.605,4.605,0,0,1-3.139.469h0s4.426-1.341,7.06-8.472c.807-2.184,1.927-13.747.964-15.16-1.9-2.793-12.527-3.084-15.666-8.266q.232-.289.429-.578c.01-.016.023-.031.034-.047a5.941,5.941,0,0,0,.363-.617C90,315.116,105.125,308.949,105.125,321.283Z",
    transform: "translate(-63.785 -293.532)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.066,260.879c6.714.376,17.178,1.605,21.091,10.066,1.278,2.759,3.372,10.8,2.875,19.711s-8.481,20.037-8.481,20.037-3.307,2.954-4,3.373c-2.7,1.63-2.725,5.337-13.056,5.337l-6.167-43.169",
    transform: "translate(-41.035 -260.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M105.578,260.673c2.859,0,8.179,2.185,8.179,2.185a52.954,52.954,0,0,1,3.488,6.508,22.334,22.334,0,0,1,1.544,5.476c-8-1.349-11.283,4.621-19.378,1.248l6.167,43.169a40.449,40.449,0,0,1-20.462-5.441,2.3,2.3,0,0,1-1.125-1.964C83.88,290.349,81.174,260.673,105.578,260.673Z",
    transform: "translate(-79.367 -260.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M161,315.821c-.1-18.479-2.091-42.973,12.83-49.506.26,1.352.732,5.126-.493,7.575-3.084,6.167-6.167,6.167-9.251,10.792-3.084,16.959,5.892,34.959,8.873,37.41h0a38.787,38.787,0,0,1-10.833-4.307A2.3,2.3,0,0,1,161,315.821Z",
    transform: "translate(-156.378 -264.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.023,419.672l13.758-5.732a3.083,3.083,0,0,0,1.9-2.846v-3.726H92.1v3.726a3.083,3.083,0,0,0,1.9,2.846h0c.217.091-2.456.607-1.6,1.016,3.316,1.592-1.11.831-1.11,2.463L88.052,421c0,1.448-6.113,2.4-7.56,2.4L60.8,430.571a2.621,2.621,0,0,1-2.621-2.621v-4.009A4.626,4.626,0,0,1,61.023,419.672Z",
    transform: "translate(-58.176 -363.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M60.732,435.717l13.3-5.543L84.1,434.517l10.062-4.343h0a10.544,10.544,0,0,1-2.034,3.531,27.832,27.832,0,0,1-4.1,3.633,37.872,37.872,0,0,1-8.258,5.193A37.414,37.414,0,0,1,69,445.956a59.686,59.686,0,0,1-8.5.66,2.621,2.621,0,0,1-2.621-2.621v-4.009A4.625,4.625,0,0,1,60.732,435.717Z",
    transform: "translate(-57.885 -379.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M94.691,407.367h15.418v3.726a3.083,3.083,0,0,0,1.9,2.846l-.78.74C94.784,418.872,94.691,407.367,94.691,407.367Z",
    transform: "translate(-76.189 -363.813)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.794)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.535,459.6v-4.009a4.615,4.615,0,0,1,1.306-3.208l6.209,4.9a4.625,4.625,0,0,1,1.736,3.612v.86a5.5,5.5,0,0,1-1.736.219c-1.657.116-4.894.243-4.894.243A2.621,2.621,0,0,1,189.535,459.6Z",
    transform: "translate(-189.535 -443.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M128.965,450.405c.771-.491,1.34-.939,1.34-.939V444.78h-3.084v6.649S128.194,450.9,128.965,450.405Z",
    transform: "translate(-102.552 -437.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M91.981,428.511l8.824-6.618a1.233,1.233,0,0,1,1.766.3l.457,1.889s-.1.1-1.059,1.322c-.107.13-1.165,1.385-1.165,1.385L98.863,429,95.7,431.46Z",
    transform: "translate(-65.77 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M144.749,428.511l-8.825-6.618a1.233,1.233,0,0,0-1.766.3l-1.744,2.615,5.41,7.574a1.234,1.234,0,0,0,1.774.246Z",
    transform: "translate(-118.538 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M89.108,307.407c7.709,7.708,22.838,1.542,22.838,13.876l-.957,9.086a6.167,6.167,0,0,1-3.147,4.833l-8.779,4.877a4.625,4.625,0,0,1-4.492,0L85.793,335.2a6.167,6.167,0,0,1-3.147-4.833l-1.105-10.79a17.02,17.02,0,0,1-.069-2.308C82.048,313.345,87.566,310.491,89.108,307.407Z",
    transform: "translate(-70.606 -293.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.125,321.283l-.957,9.086a6.167,6.167,0,0,1-3.147,4.833l-8.779,4.877a4.605,4.605,0,0,1-3.139.469h0s4.426-1.341,7.06-8.472c.807-2.184,1.927-13.747.964-15.16-1.9-2.793-12.527-3.084-15.666-8.266q.232-.289.429-.578c.01-.016.023-.031.034-.047a5.941,5.941,0,0,0,.363-.617C90,315.116,105.125,308.949,105.125,321.283Z",
    transform: "translate(-63.785 -293.531)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.558 -7.044)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.461,321.283l.957,9.086a6.167,6.167,0,0,0,3.147,4.833l8.779,4.877a4.605,4.605,0,0,0,3.139.469h0s-4.426-1.341-7.06-8.472c-.807-2.184-1.927-13.747-.964-15.161,1.9-2.793,12.527-3.084,15.666-8.266q-.232-.289-.429-.578c-.01-.016-.023-.031-.034-.047a5.941,5.941,0,0,1-.363-.617C96.59,315.116,81.461,308.949,81.461,321.283Z",
    transform: "translate(-71.948 -289.221)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.884 4.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.367,260.879c-6.714.376-17.178,1.605-21.091,10.066C57,273.7,54.9,281.744,55.4,290.656s8.48,20.037,8.48,20.037,3.307,2.954,4,3.373c2.7,1.63,2.725,5.338,13.055,5.338l6.167-43.169",
    transform: "translate(-59.429 -260.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M97.061,260.673c-2.858,0-8.179,2.185-8.179,2.185a52.956,52.956,0,0,0-3.488,6.508,22.335,22.335,0,0,0-1.544,5.476c8-1.349,11.283,4.621,19.378,1.248l-6.167,43.17a40.449,40.449,0,0,0,20.461-5.442,2.3,2.3,0,0,0,1.125-1.964C118.759,290.35,121.465,260.673,97.061,260.673Z",
    transform: "translate(-81.303 -260.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M174,315.821c.1-18.479,2.091-42.974-12.829-49.506-.26,1.352-.732,5.126.493,7.575,3.084,6.167,6.167,6.167,9.251,10.792,3.084,16.959-5.892,34.959-8.873,37.41h0a38.785,38.785,0,0,0,10.833-4.307A2.3,2.3,0,0,0,174,315.821Z",
    transform: "translate(-136.658 -264.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M91.16,419.672,77.4,413.94a3.083,3.083,0,0,1-1.9-2.846v-3.726H60.087v3.726a3.083,3.083,0,0,1-1.9,2.846h0c-.217.091,2.456.607,1.6,1.016-3.316,1.592,1.11.831,1.11,2.463L64.131,421c0,1.448,6.113,2.4,7.56,2.4l19.694,7.17c1.447,0-.226-.138-.226-1.585v-3.521s.009-1.24,0-1.523C91.166,422.357,92.882,420.39,91.16,419.672Z",
    transform: "translate(-52.038 -363.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M91.311,435.717l-13.3-5.543-10.062,4.343-10.062-4.343h0a10.545,10.545,0,0,0,2.034,3.531,27.832,27.832,0,0,0,4.1,3.633,37.871,37.871,0,0,0,8.258,5.193,37.413,37.413,0,0,0,10.768,3.424,59.685,59.685,0,0,0,8.5.66c1.447,0-.226.787-.226-.66l.226-5.327C91.537,438.76,93.035,436.435,91.311,435.717Z",
    transform: "translate(-52.189 -379.858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M112.007,407.367H96.589v3.726a3.083,3.083,0,0,1-1.9,2.846l.78.74C111.914,418.872,112.007,407.367,112.007,407.367Z",
    transform: "translate(-88.54 -363.813)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.781 47.794)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M195.729,460.421v-3.887c0-1.223.817-2.494,0-3.34l-4.458,4.092a4.625,4.625,0,0,0-1.736,3.612v.86a5.5,5.5,0,0,0,1.736.219c1.657.116,4.894.243,4.894.243C197.612,462.221,195.729,461.868,195.729,460.421Z",
    transform: "translate(-161.598 -443.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M128.561,450.405c-.771-.491-1.34-.939-1.34-.939V444.78H130.3v6.649S129.332,450.9,128.561,450.405Z",
    transform: "translate(-117.786 -437.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M103.029,428.511,94.2,421.894a1.233,1.233,0,0,0-1.766.3l-.457,1.889s.1.1,1.059,1.322c.107.13,1.165,1.385,1.165,1.385L96.147,429l3.158,2.459Z",
    transform: "translate(-92.052 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M132.414,428.511l8.824-6.618a1.233,1.233,0,0,1,1.766.3l1.744,2.615-5.41,7.574a1.234,1.234,0,0,1-1.774.246Z",
    transform: "translate(-121.437 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M104.3,307.407c-7.709,7.708-22.838,1.542-22.838,13.876l.957,9.086a6.167,6.167,0,0,0,3.147,4.833l8.779,4.877a4.625,4.625,0,0,0,4.492,0l8.779-4.877a6.167,6.167,0,0,0,3.147-4.833l1.105-10.79a17.021,17.021,0,0,0,.069-2.308C111.359,313.345,105.84,310.491,104.3,307.407Z",
    transform: "translate(-80.831 -293.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.461,321.283l.957,9.086a6.167,6.167,0,0,0,3.147,4.833l8.779,4.877a4.605,4.605,0,0,0,3.139.469h0s-4.426-1.341-7.06-8.472c-.807-2.184-1.927-13.747-.964-15.161,1.9-2.793,12.527-3.084,15.666-8.266q-.232-.289-.429-.578c-.01-.016-.023-.031-.034-.047a5.941,5.941,0,0,1-.363-.617C96.59,315.116,81.461,308.949,81.461,321.283Z",
    transform: "translate(-80.832 -293.531)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-.13,5.124l83.443-.033a13.285,13.285,0,0,0,.281-2.532A13.8,13.8,0,0,0,83.313,0L-.13.067s-.08,1.212-.08,2.476S-.13,5.124-.13,5.124Z",
    transform: "translate(24.833 -19.513) rotate(90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanningIcn);
export default __webpack_public_path__ + "static/media/scanning_icn.95db383257aa617e91f1bd296d3395ea.svg";
export { ForwardRef as ReactComponent };